import dayjs from "$routes/_lib/dayjs";
import { useFormatPenceFactory } from "$routes/_lib/use-format-pence";
import InvoiceType, {
  TransactionType,
} from "$routes/patient/[:patientId]/_lib/invoices/invoice-type";
import { Box, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

const TransactionLines = ({ invoice }) => {
  const { created, transactions } = invoice;
  const timestampFormatted = dayjs(created).format("DD/MM/YYYY HH:mm");
  const formatPence = useFormatPenceFactory();
  const filteredTransactions = transactions.filter(
    (t) => t.payer.type !== "INSURER",
  );

  return (
    <Box display="flex" flexDirection="column" width="100%" my={2}>
      {filteredTransactions.length > 1 && (
        <strong>
          <FormattedMessage
            id="invoice.laserReceipt.transaction.heading"
            defaultMessage="{length} Transactions"
            values={{ length: filteredTransactions.length }}
          />
        </strong>
      )}
      {filteredTransactions.map((tx) => (
        <Box mb={2} key={tx._id}>
          {(tx?.payment?.authCode || tx?.refund?.authCode) && (
            <Box>
              <FormattedMessage
                id="invoice.laserReceipt.transaction.authCode"
                defaultMessage="Transaction code: {code}"
                values={{ code: tx?.payment?.authCode || tx?.refund?.authCode }}
              />
            </Box>
          )}
          <Box>
            <Typography
              style={{ textTransform: "capitalize", fontSize: "inherit" }}
            >
              {tx.payer.type.toLowerCase()}
              {": "}
              <strong>{formatPence(tx.amount.value)}</strong>
            </Typography>
          </Box>
          {tx.actionedBy && (
            <Box>
              <FormattedMessage
                id="invoice.laserReceipt.transaction.servedBy"
                defaultMessage="Served by: {name}"
                values={{
                  name: `${tx.actionedBy.person.firstname ?? ""} ${
                    tx.actionedBy.person.lastname ?? ""
                  }`,
                }}
              />
            </Box>
          )}
        </Box>
      ))}
      <FormattedMessage
        id="invoice.laserReceipt.transaction.date"
        defaultMessage="On: {date}"
        values={{
          date: timestampFormatted,
        }}
      />
    </Box>
  );
};

TransactionLines.propTypes = {
  invoice: InvoiceType.isRequired,
  transactions: PropTypes.arrayOf(TransactionType).isRequired,
};

export default TransactionLines;
